<template>
  <div>
    <div class="row">
      <div class="col-md-12" style="padding-left: 10%; padding-right: 10%;">
        <div id="formStatusPlan" class="bg-plans-form">
          <h2>
            สถานะการดำเนินงาน
          </h2>
          <br />
          <b-row>
            <b-col>
              <h4>
                <span>ส่งใบราคา</span>
                <span class="plans-form-job-status-date" v-if="formJobStatus.invoice.date != ''">{{
                  formJobStatus.invoice.date }}</span>
              </h4>
              <b-form-textarea id="detail-invoice" placeholder="กรอกรายละเอียด" rows="4"
                v-model="formJobStatus.invoice.detail" :disabled="formJobStatus.invoice.flagUpdate">
              </b-form-textarea>
              <div class="mt-3 flex-content-start"
                v-if="(pageStage == 'update' || pageStage == 'edit') && formJobStatus.invoice.date == ''">
                <div class="row pt-4 px-4">
                  <b-button variant="success" @click="formJobInvoiceSave()"><i
                      class="fas fa-paper-plane"></i></b-button>
                  <label class="checkbox ml-2">
                    <input type="checkbox" id="ck_new_date_invoice" />
                    <span></span> &nbsp; บันทึกเวลาล่าสุด
                  </label>
                </div>
              </div>
              <div class="mt-3 flex-content-end" v-if="pageStage == 'update' || pageStage == 'edit'">
                <b-button variant="warning" @click="formJobInvoiceSave('edit')"
                  v-if="formJobStatus.invoice.date != ''"><i class="fas fa-pen"></i></b-button>
              </div>
            </b-col>
            <b-col>
              <h4>
                <span>ลูกค้าอนุมัติ</span>
                <span class="plans-form-job-status-date" v-if="formJobStatus.approval.date != ''">{{
                  formJobStatus.approval.date }}</span>
              </h4>
              <b-form-textarea id="detail-approval" placeholder="กรอกรายละเอียด" rows="4"
                v-model="formJobStatus.approval.detail" :disabled="formJobStatus.approval.flagUpdate"></b-form-textarea>
              <div class="mt-3 flex-content-start"
                v-if="(pageStage == 'update' || pageStage == 'edit') && formJobStatus.approval.date == ''">
                <div class="row pt-4 px-4">
                  <b-button variant="success" @click="formJobApprovalSave()"><i
                      class="fas fa-paper-plane"></i></b-button>
                  <label class="checkbox ml-2">
                    <input type="checkbox" id="ck_new_date_approval" />
                    <span></span> &nbsp; บันทึกเวลาล่าสุด
                  </label>
                </div>
              </div>
              <div class="mt-3 flex-content-end" v-if="pageStage == 'update' || pageStage == 'edit'">
                <b-button variant="warning" @click="formJobApprovalSave('edit')"
                  v-if="formJobStatus.approval.date != ''"><i class="fas fa-pen"></i></b-button>
              </div>
            </b-col>
            <b-col>
              <h4>
                <span>สั่งซื้ออะไหล่</span>
                <span class="plans-form-job-status-date" v-if="formJobStatus.parts.date != ''">{{
                  formJobStatus.parts.date
                }}</span>
              </h4>
              <b-form-textarea id="detail-parts" placeholder="กรอกรายละเอียด" rows="4"
                v-model="formJobStatus.parts.detail" :disabled="formJobStatus.parts.flagUpdate"></b-form-textarea>
              <div class="mt-3 flex-content-start"
                v-if="(pageStage == 'update' || pageStage == 'edit') && formJobStatus.parts.date == ''">
                <div class="row pt-4 px-4">
                  <b-button variant="success" @click="formJobPartsSave()"><i class="fas fa-paper-plane"></i></b-button>
                  <label class="checkbox ml-2">
                    <input type="checkbox" id="ck_new_date_parts" />
                    <span></span> &nbsp; บันทึกเวลาล่าสุด
                  </label>
                </div>
              </div>
              <div class="mt-3 flex-content-end"
                v-if="(pageStage == 'update' || pageStage == 'edit') && formJobStatus.parts.date != ''">
                <b-button variant="warning" @click="formJobPartsSave('edit')"><i class="fas fa-pen"></i></b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-row>
                <b-col class="form-inline" sm="4">
                  <label class="" for="inline-form-custom-select-pref">ทีมปฏิบัติการ</label>
                </b-col>
                <b-col sm="8">
                  <b-form-select id="form_sel_team" class="plans-form-select custom-select2"
                    v-model="formJobStatus.team" :options="formSetting.teamData"></b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="form-inline" sm="4">
                  <label class="" for="inline-form-custom-select-pref">นัดหมาย</label>
                </b-col>
                <b-col sm="8">
                  <date-picker v-model="formJobStatus.appointmentDate" type="datetime"></date-picker>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="form-inline" sm="4">
                  <label class="" for="inline-form-custom-select-pref">วันที่เข้าซ่อม</label>
                </b-col>
                <b-col sm="8">
                  <date-picker v-model="formJobStatus.serviceDate" type="datetime"></date-picker>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="flex-content-end">
              <b-form-input style="width: 100px; margin: 0;" class="plans-form-select-lg"
                v-model="formJobStatus.statusDetail" placeholder="รายละเอียดสถานะ"></b-form-input>
              <b-form-select style="width: 50px;" class="plans-form-select ml-4" v-model="formJobStatus.planStatus"
                :options="formSetting.planStatus"></b-form-select>
              <b-button class="btn-width-150 ml-4" variant="primary" @click="formJobStatusSave()"
                v-if="pageStage == 'update' || pageStage == 'edit'">
                <i class="fas fa-save"></i>
                บันทึกการดำเนินงาน
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div id="formImgDoc" class="bg-plans-form mt-10" v-if="pageStage == 'update' || pageStage == 'edit'">
          <h2>
            รูปภาพ และเอกสาร
          </h2>
          <br />
          <b-tabs content-class="mt-3" v-model="tabIndex" pills card>
            <b-tab title="แผนงาน" active>
              <viewer :images="formImages" class="image-container" v-show="showTabImgDoc && formImages.length > 0">
                <img class="image" v-for="src in formImages" :key="src.name" :src="src.url" width="250">
              </viewer>
              <div class="mt-6" v-show="showTabImgDoc && formDoc.length > 0">
                <b-link v-for="src in formDoc" :key="src" :href="src.url" target="_blank">
                  <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ src.name }}
                </b-link>
              </div>
              <div style="display: flex; justify-content: center; align-items: center;"
                v-if="showTabImgDoc && formImages.length == 0 && formDoc.length == 0">
                <i class="far fa-file-excel fa-5x"></i>&nbsp;&nbsp;&nbsp;
                <h3 style="color: #B5B5C3">
                  ไม่มีรูปภาพ และเอกสาร
                </h3>
              </div>
              <div v-show="!showTabImgDoc">
                <b-button class="mb-4" @click="openModalDropzone" variant="success"><i class="fas fa-upload"></i>
                  อัพโหลด</b-button>
                <b-table class="mt-4" hover :items="tableImgDocItem.items" :fields="tableImgDocItem.fields"
                  :bordered="true" :striped="false" head-variant="light">
                  <template #cell(ex)="data">
                    <img class="image" :src="data.item.data.url" width="250" v-if="data.item.type == 'image'">
                    <b-link :href="data.item.data.url" target="_blank" v-else>
                      <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ data.item.data.name }}
                    </b-link>
                  </template>
                  <template #cell(action)="data">
                    <b-button @click="confirmTableImgDocItemDelete(data)" variant="danger">ลบ</b-button>
                  </template>
                </b-table>
              </div>
            </b-tab>
            <b-tab title="ใบเสนอราคา">
              <viewer :images="formImages_2" class="image-container" v-show="showTabImgDoc">
                <img class="image" v-for="src in formImages_2" :key="src.name" :src="src.url" width="250">
              </viewer>
              <div class="mt-6" v-show="showTabImgDoc && formDoc_2.length > 0">
                <b-link v-for="src in formDoc_2" :key="src" :href="src.url" target="_blank">
                  <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ src.name }}
                </b-link>
              </div>
              <div style="display: flex; justify-content: center; align-items: center;"
                v-if="showTabImgDoc && formImages_2.length == 0 && formDoc_2.length == 0">
                <i class="far fa-file-excel fa-5x"></i>&nbsp;&nbsp;&nbsp;
                <h3 style="color: #B5B5C3">
                  ไม่มีรูปภาพ และเอกสาร
                </h3>
              </div>
              <div v-show="!showTabImgDoc">
                <b-button class="mb-4" @click="openModalDropzone" variant="success"><i class="fas fa-upload"></i>
                  อัพโหลด</b-button>
                <b-table class="mt-4" hover :items="tableImgDocItem.items" :fields="tableImgDocItem.fields"
                  :bordered="true" :striped="false" head-variant="light">
                  <template #cell(ex)="data">
                    <img class="image" :src="data.item.data.url" width="250" v-if="data.item.type == 'image'">
                    <b-link :href="data.item.data.url" target="_blank" v-else>
                      <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ data.item.data.name }}
                    </b-link>
                  </template>
                  <template #cell(action)="data">
                    <b-button @click="confirmTableImgDocItemDelete(data)" variant="danger">ลบ</b-button>
                  </template>
                </b-table>
              </div>
            </b-tab>
            <b-tab title="ลูกค้าอนุมัติ">
              <viewer :images="formImages_3" class="image-container" v-show="showTabImgDoc">
                <img class="image" v-for="src in formImages_3" :key="src.name" :src="src.url" width="250">
              </viewer>
              <div class="mt-6" v-show="showTabImgDoc && formDoc_3.length > 0">
                <b-link v-for="src in formDoc_3" :key="src" :href="src.url" target="_blank">
                  <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ src.name }}
                </b-link>
              </div>
              <div style="display: flex; justify-content: center; align-items: center;"
                v-if="showTabImgDoc && formImages_3.length == 0 && formDoc_3.length == 0">
                <i class="far fa-file-excel fa-5x"></i>&nbsp;&nbsp;&nbsp;
                <h3 style="color: #B5B5C3">
                  ไม่มีรูปภาพ และเอกสาร
                </h3>
              </div>
              <div v-show="!showTabImgDoc">
                <b-button class="mb-4" @click="openModalDropzone" variant="success"><i class="fas fa-upload"></i>
                  อัพโหลด</b-button>
                <b-table class="mt-4" hover :items="tableImgDocItem.items" :fields="tableImgDocItem.fields"
                  :bordered="true" :striped="false" head-variant="light">
                  <template #cell(ex)="data">
                    <img class="image" :src="data.item.data.url" width="250" v-if="data.item.type == 'image'">
                    <b-link :href="data.item.data.url" target="_blank" v-else>
                      <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ data.item.data.name }}
                    </b-link>
                  </template>
                  <template #cell(action)="data">
                    <b-button @click="confirmTableImgDocItemDelete(data)" variant="danger">ลบ</b-button>
                  </template>
                </b-table>
              </div>
            </b-tab>
            <b-tab title="สั่งซื้ออะไหล่">
              <viewer :images="formImages_4" class="image-container" v-show="showTabImgDoc">
                <img class="image" v-for="src in formImages_4" :key="src.name" :src="src.url" width="250">
              </viewer>
              <div class="mt-6" v-show="showTabImgDoc && formDoc_4.length > 0">
                <b-link v-for="src in formDoc_4" :key="src" :href="src.url" target="_blank">
                  <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ src.name }}
                </b-link>
              </div>
              <div style="display: flex; justify-content: center; align-items: center;"
                v-if="showTabImgDoc && formImages_4.length == 0 && formDoc_4.length == 0">
                <i class="far fa-file-excel fa-5x"></i>&nbsp;&nbsp;&nbsp;
                <h3 style="color: #B5B5C3">
                  ไม่มีรูปภาพ และเอกสาร
                </h3>
              </div>
              <div v-show="!showTabImgDoc">
                <b-button class="mb-4" @click="openModalDropzone" variant="success"><i class="fas fa-upload"></i>
                  อัพโหลด</b-button>
                <b-table class="mt-4" hover :items="tableImgDocItem.items" :fields="tableImgDocItem.fields"
                  :bordered="true" :striped="false" head-variant="light">
                  <template #cell(ex)="data">
                    <img class="image" :src="data.item.data.url" width="250" v-if="data.item.type == 'image'">
                    <b-link :href="data.item.data.url" target="_blank" v-else>
                      <i class="fas fa-file-pdf fa-lg"></i>&nbsp;&nbsp;{{ data.item.data.name }}
                    </b-link>
                  </template>
                  <template #cell(action)="data">
                    <b-button @click="confirmTableImgDocItemDelete(data)" variant="danger">ลบ</b-button>
                  </template>
                </b-table>
              </div>
            </b-tab>
          </b-tabs>
          <hr />
          <b-row v-show="dropzoneStageBtn == 'editSave'">
            <b-col class="flex-content-end">
              <b-button class="btn-width-100" variant="outline-danger" @click="formEditImgDocCancel()">
                <i class="fas fa-times"></i>
                ยกเลิก
              </b-button>
              <!-- <b-button class="btn-width-100" variant="primary" @click="formEditImgDocSave()">
                <i class="far fa-save"></i>
                บันทึก
              </b-button> -->
            </b-col>
          </b-row>
          <b-row v-show="dropzoneStageBtn == 'editOpen'">
            <b-col class="flex-content-end">
              <b-button class="btn-width-100" variant="warning" @click="formEditImgDoc()">
                <i class="fas fa-cog"></i>
                แก้ไข
              </b-button>
            </b-col>
          </b-row>
        </div>

        <div id="formUpload" class="bg-plans-form mt-10" v-if="pageStage == 'new'">
          <h2>
            รูปภาพ และเอกสาร
          </h2>
          <br />
          <h3 class="mb-4">
            แผนงาน
          </h3>
          <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
          <br />
          <br />
          <h3 class="mb-4">
            ใบเสนอราคา
          </h3>
          <vue-dropzone ref="myVueDropzone2" id="dropzone2" :options="dropzoneOptions"></vue-dropzone>
          <br />
          <br />
          <h3 class="mb-4">
            ลูกค้าอนุมัติ
          </h3>
          <vue-dropzone ref="myVueDropzone3" id="dropzone3" :options="dropzoneOptions"></vue-dropzone>
          <br />
          <br />
          <h3 class="mb-4">
            สั่งซื้ออะไหล่
          </h3>
          <vue-dropzone ref="myVueDropzone4" id="dropzone4" :options="dropzoneOptions"></vue-dropzone>
        </div>

        <div id="formEquipment" class="bg-plans-form mt-10">
          <h2>
            อุปกรณ์ที่เสนอ
          </h2>
          <br />
          <b-row class="pl-4 pr-4" align-h="between">
            <b-button class="mb-4" @click="equipmentActionAdd" variant="primary"> + เพิ่มรายการ</b-button>
            <b-button class="mb-4" @click="equipmentActionSelect" variant="success"><i class="fas fa-check"></i> อนุมัติทั้งหมด</b-button>
          </b-row>
          <b-table class="mt-4" hover :items="equipmentOffered.items" :fields="equipmentOffered.fields" :bordered="true"
            :striped="false" head-variant="light" :select-mode="selectMode" :tbody-tr-class="rowClass" :key="tableKey">
            <template #cell(select)="data">
              <b-button @click="toggleSelection(data.item)" :variant="data.item.selected ? 'success' : 'outline-secondary'">
                {{ data.item.selected ? 'อนุมัติแล้ว' : 'ยังไม่อนุมัติ' }}
              </b-button>
            </template>
            <template #cell(action)="data">
              <b-button @click="equipmentActionDelete(data)" class="ml-2" variant="danger">ลบ</b-button>
              <b-button @click="equipmentActionEdit(data)" class="ml-2" variant="warning">แก้ไข</b-button>
            </template>
          </b-table>
          <div class="row justify-content-between mt-4 mx-2">
            <div>
              <b-form inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref" style="line-height: 33px;">ราคาทุนรวม : {{
                  this.equipmentOffered.totalCost }}</label>
              </b-form>
              <b-form inline>
                <label class="mr-sm-2" for="inline-form-custom-select-pref" style="line-height: 33px;">ราคาขายรวม : {{
                  this.equipmentOffered.totalPrice }}</label>
              </b-form>
            </div>
            <div>
              <b-form inline class="justify-content-end">
                <label class="mr-sm-2" for="inline-form-custom-select-pref">ส่วนลด</label>
                <b-form-input class="mb-2 mr-sm-2 mb-sm-0" type="number" v-model="equipmentOffered.discount" size="sm"
                  placeholder="0"></b-form-input>
              </b-form>
              <b-form inline class="justify-content-end">
                <label class="mr-sm-2" for="inline-form-custom-select-pref">Net Total</label>
                <b-form-input class="mb-2 mr-sm-2 mb-sm-0" v-model="equipmentOffered.netTotal" size="sm" placeholder="0"
                  disabled></b-form-input>
              </b-form>
            </div>
          </div>
          <!-- <div v-if="this.paramsPlanId" class="mt-8">
            <b-row v-if="equipmentState == 'edit'">
              <b-col class="flex-content-end">
                <b-button class="btn-width-100" variant="outline-danger" @click="formEditEquipment('cancel')">
                  <i class="fas fa-times"></i>
                  ยกเลิก
                </b-button>
                <b-button class="btn-width-100 ml-2" variant="primary" @click="formEditEquipment('save')">
                  <i class="far fa-save"></i>
                  บันทึก
                </b-button>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col class="flex-content-end">
                <b-button class="btn-width-100" variant="warning" @click="formEditEquipment('edit')">
                  <i class="fas fa-cog"></i>
                  แก้ไข
                </b-button>
              </b-col>
            </b-row>
          </div> -->
        </div>

        <div id="formInfoPlan" class="bg-plans-form mt-10">
          <h2>
            ข้อมูลแผนงาน
          </h2>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">วันที่แจ้ง</label>
            <div>
              <date-picker v-model="form.createDate" type="datetime"></date-picker>
            </div>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">ประเภทงาน</label>
            <b-form-select id="form_sel_jobType" class="plans-form-select custom-select2" v-model="form.jobType"
              :options="formSetting.jobType"></b-form-select>

          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">บริษัท</label>
            <b-form-select id="form_sel_company" class="plans-form-select-lg custom-select2" v-model="form.companyData"
              :options="formSetting.companyData"></b-form-select>
            <b-button class="ml-4" variant="primary" @click="companyActionModal()">+ เพิ่มบริษัท</b-button>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">ที่อยู่</label>
            <b-form-input class="mr-sm-2 mb-sm-0 plans-form-select-lx" v-model="form.address" size="sm"></b-form-input>

            <label class="mr-sm-2" for="inline-form-custom-select-pref">ที่อยู่ 2</label>
            <b-form-input class="mr-sm-2 mb-sm-0 plans-form-select-lx" v-model="form.address2" size="sm"></b-form-input>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">ตำบล/แขวง</label>
            <b-form-select id="form_subDistrict" class="plans-form-select custom-select2" v-model="form.subDistrict"
              :options="formSetting.subDistrict"></b-form-select>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">อำเภอ/เขต</label>
            <b-form-select id="form_district" class="plans-form-select custom-select2" v-model="form.district"
              :options="formSetting.district"></b-form-select>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">จังหวัด</label>
            <b-form-select id="form_province" class="plans-form-select custom-select2" v-model="form.province"
              :options="formSetting.province"></b-form-select>

          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">รหัสไปรษณีย์</label>
            <b-form-input type="number" class="mb-2 mr-sm-2 mb-sm-0" v-model="form.postCode" size="sm"></b-form-input>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">เลขประจำตัวผู้เสียภาษี</label>
            <b-form-input type="number" class="mb-2 mr-sm-2 mb-sm-0 plans-form-select" v-model="form.taxId"
              size="sm"></b-form-input>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">ชื่ออาคาร</label>
            <b-form-select id="form_sel_building_name" class="custom-select2 plans-form-select-lg"
              v-model="form.buildingData" :options="formSetting.buildingData"></b-form-select>
            <b-button class="ml-4" variant="primary" @click="buildingActionModal()">+ เพิ่มอาคาร</b-button>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">ยี่ห้อ</label>
            <b-form-input class="mb-2 mr-sm-2 mb-sm-0" v-model="form.brandName" size="sm"></b-form-input>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">จำนวนลิฟท์</label>
            <b-form-input type="number" class="mb-2 mr-sm-2 mb-sm-0" v-model="form.numberOfElevator"
              size="sm"></b-form-input>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">จำนวนชั้น</label>
            <b-form-input type="number" class="mb-2 mr-sm-2 mb-sm-0" v-model="form.numberOfFloors"
              size="sm"></b-form-input>

          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">พิกัด</label>
            <b-form-input class="mb-2 mr-sm-2 mb-sm-0 plans-form-select-lx" v-model="form.locationUrl"
              size="sm"></b-form-input>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">ชื่อผู้ติดต่อ</label>
            <b-form-select id="form_sel_contact" class="plans-form-select-lg custom-select2" v-model="form.contactName"
              :options="formSetting.contactData"></b-form-select>
            <b-button class="ml-4" variant="primary" @click="contactActionModal()">+ เพิ่มผู้ติดต่อ</b-button>

            <label class="mr-sm-2 ml-4" for="inline-form-custom-select-pref">เบอร์โทร</label>
            <b-form-input type="number" class="mb-2 mr-sm-2 mb-sm-0" v-model="form.contactPhone"
              size="sm"></b-form-input>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">อีเมล</label>
            <b-form-input class="mb-2 mr-sm-2 mb-sm-0 plans-form-select-lg" v-model="form.contactEmail"
              size="sm"></b-form-input>
          </b-form>
          <br />
          <b-form inline>
            <label class="mr-sm-2" for="inline-form-custom-select-pref">รายละเอียดเพิ่มเติม</label>
            <b-form-textarea class="mb-2 mr-sm-2 mb-sm-0 plans-form-select-lx" v-model="form.detail"></b-form-textarea>
          </b-form>
        </div>

        <br />
        <b-row v-if="pageStage == 'new'">
          <b-col class="flex-content-end">
            <b-button class="btn-width-100" variant="primary" @click="formPlanSave()">
              <i class="far fa-save"></i>
              บันทึก
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="pageStage == 'update'">
          <b-col class="flex-content-end">
            <b-button class="btn-width-100 mr-2" variant="outline-secondary" @click="formPlanDel()">
              <i class="fas fa-trash"></i>
              ลบ
            </b-button>
            <b-button class="btn-width-150" variant="primary" @click="formPlanUpdate()">
              <i class="fas fa-save"></i>
              บันทึกการแก้ไข
            </b-button>
          </b-col>
        </b-row>

        <b-modal ref="equipmentActionModal" centered size="sm" title="เพิ่มรายการ">
          <label class="mr-sm-2">รายการ</label>
          <b-form-input v-model="equipmentCreateForm.equipmentText" size="sm"></b-form-input>
          <label class="mr-sm-2 mt-3">ราคาทุน</label>
          <b-form-input key="createCost" type="number" v-model="equipmentCreateForm.equipmentCost" size="sm"
            @input="calTotalCostCreateForm()"></b-form-input>
          <label class="mr-sm-2 mt-3">จำนวน</label>
          <b-form-input key="createAmount" type="number" v-model="equipmentCreateForm.equipmentAmount" size="sm"
            @input="calTotalCostCreateForm()"></b-form-input>
          <label class="mr-sm-2 mt-3">ราคาทุนรวม</label>
          <b-form-input key="createTotalCost" type="number" v-model="equipmentCreateForm.equipmentTotalCost" size="sm"
            disabled></b-form-input>
          <label class="mr-sm-2 mt-3">ราคาขาย</label>
          <b-form-input key="createPrice" type="number" v-model="equipmentCreateForm.equipmentPrice"
            size="sm"></b-form-input>
          <template #modal-footer="{ cancel }">
            <b-button variant="success" @click="addEquipment()">
              ยืนยัน
            </b-button>
            <b-button variant="danger" @click="cancel()">
              ยกเลิก
            </b-button>
          </template>
        </b-modal>

        <b-modal id="companyCreateForm" ref="companyActionModal" centered no-enforce-focus size="lg"
          title="เพิ่มบริษัท">
          <label class="mr-sm-2">บริษัท</label>
          <b-form-input v-model="companyCreateForm.companyName" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">ที่อยู่</label>
          <b-form-input v-model="companyCreateForm.address" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">ที่อยู่ 2</label>
          <b-form-input v-model="companyCreateForm.address2" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">ตำบล</label>
          <b-form-select id="companyCreateForm_subDistrict" class="plans-form-select custom-select2"
            v-model="companyCreateForm.subDistrict" :options="formSetting.subDistrict"></b-form-select>

          <label class="mr-sm-2 mt-3">อำเภอ/เขต</label>
          <b-form-select id="companyCreateForm_district" class="plans-form-select custom-select2"
            v-model="companyCreateForm.district" :options="formSetting.district"></b-form-select>

          <label class="mr-sm-2 mt-3">จังหวัด</label>
          <b-form-select id="companyCreateForm_province" class="plans-form-select custom-select2"
            v-model="companyCreateForm.province" :options="formSetting.province"></b-form-select>

          <label class="mr-sm-2 mt-3">รหัสไปรษณีย์</label>
          <b-form-input type="number" v-model="companyCreateForm.postCode" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">เลขประจำตัวผู้เสียภาษี</label>
          <b-form-input type="number" v-model="companyCreateForm.taxId" size="sm"></b-form-input>

          <template #modal-footer="{ cancel }">
            <b-button variant="success" @click="confirmActionCompany()">
              ยืนยัน
            </b-button>
            <b-button variant="danger" @click="cancel()">
              ยกเลิก
            </b-button>
          </template>
        </b-modal>

        <b-modal id="buildingCreateForm" ref="buildingActionModal" centered no-enforce-focus size="lg"
          title="เพิ่มอาคาร">
          <label class="mr-sm-2">ชื่ออาคาร</label>
          <b-form-input v-model="buildingCreateForm.buildingName" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">ยี่ห้อ</label>
          <b-form-input v-model="buildingCreateForm.brandName" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">จำนวนลิฟท์</label>
          <b-form-input v-model="buildingCreateForm.numberOfElevator" size="sm" type="number"></b-form-input>

          <label class="mr-sm-2 mt-3">จำนวนชั้น</label>
          <b-form-input v-model="buildingCreateForm.numberOfFloors" size="sm" type="number"></b-form-input>

          <label class="mr-sm-2 mt-3">พิกัด</label>
          <b-form-input v-model="buildingCreateForm.locationUrl" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">บริษัท</label>
          <b-form-select id="buildingCreateForm_companyData" class="plans-form-select-lg custom-select2"
            v-model="buildingCreateForm.companyData" :options="formSetting.companyData"></b-form-select>

          <template #modal-footer="{ cancel }">
            <b-button variant="success" @click="confirmActionBuilding()">
              ยืนยัน
            </b-button>
            <b-button variant="danger" @click="cancel()">
              ยกเลิก
            </b-button>
          </template>
        </b-modal>

        <b-modal id="contactCreateForm" ref="contactActionModal" centered no-enforce-focus size="sm"
          title="เพิ่มผู้ติดต่อ">
          <label class="mr-sm-2">ชื่อผู้ติดต่อ</label>
          <b-form-input v-model="contactCreateForm.contactName" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">เบอร์โทร</label>
          <b-form-input v-model="contactCreateForm.contactPhone" size="sm" type="number"></b-form-input>

          <label class="mr-sm-2 mt-3">อีเมล</label>
          <b-form-input v-model="contactCreateForm.contactEmail" size="sm"></b-form-input>

          <label class="mr-sm-2 mt-3">บริษัท</label>
          <b-form-select id="contactCreateForm_companyData" class="plans-form-select-lg custom-select2"
            v-model="contactCreateForm.companyData" :options="formSetting.companyData"></b-form-select>

          <template #modal-footer="{ cancel }">
            <b-button variant="success" @click="confirmActionContact()">
              ยืนยัน
            </b-button>
            <b-button variant="danger" @click="cancel()">
              ยกเลิก
            </b-button>
          </template>
        </b-modal>

        <b-modal id="uploadsImgDocModal" ref="uploadsImgDocModal" centered no-enforce-focus size="lg"
          title="อัพโหลดรูปภาพ และเอกสาร">
          <vue-dropzone ref="dropzoneInModal" id="dropzoneInModal" :options="dropzoneOptions"></vue-dropzone>
          <template #modal-footer="{ cancel }">
            <b-button variant="success" @click="confirmUploadsImgDocInModal()">
              ยืนยัน
            </b-button>
            <b-button variant="danger" @click="cancel()">
              ยกเลิก
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import PlansService from "@/core/services/plans.service";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ThaiTambons from '@/assets/master_data/thai_geo_data/thai_tambons.json'
import ThaiAmphures from '@/assets/master_data/thai_geo_data/thai_amphures.json'
import ThaiProvinces from '@/assets/master_data/thai_geo_data/thai_provinces.json'
import Swal from 'sweetalert2'
import axios from 'axios'
import ApiService from "@/core/services/api.service";
import $ from "jquery";
import FetchService from "@/core/services/fetch.service";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
Vue.use(VueViewer)
export default {
  components: { DatePicker, vueDropzone: vue2Dropzone },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL || "http://localhost:3000",
      selected: [],
      pageStage: 'new',
      paramsPlanId: '',
      planByIdData: [],
      formSetting: {
        jobType: [
          {
            value: 0,
            text: 'Service'
          },
          {
            value: 1,
            text: 'Install'
          }
        ],
        companyData: [],
        address: "",
        subDistrict: [],
        district: [],
        province: [],
        postCode: "",
        taxId: "",
        locationUrl: "",
        buildingData: [],
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        detail: "",
        teamData: [],
        planStatus: [
          {
            value: 0,
            text: 'To do'
          },
          {
            value: 1,
            text: 'On going'
          },
          {
            value: 2,
            text: 'Complete'
          },
          {
            value: 3,
            text: 'In Complete'
          }
        ],
        contactData: []
      },
      form: {
        createDate: "",
        jobType: 0,
        companyData: 0,
        address: "",
        address2: "",
        subDistrict: 0,
        district: 0,
        province: 0,
        postCode: "",
        taxId: "",
        locationUrl: "",
        buildingData: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        detail: "",
        equipmentOffered: [],
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        files: [],
        files2: [],
        files3: [],
        files4: []
      },
      formJobStatus: {
        invoice: {
          date: "",
          tempDate: "",
          checkNewDate: true,
          detail: "",
          fileUpload: [],
          flagUpdate: false
        },
        approval: {
          date: "",
          tempDate: "",
          checkNewDate: false,
          detail: "",
          fileUpload: [],
          flagUpdate: false
        },
        parts: {
          date: "",
          tempDate: "",
          checkNewDate: false,
          detail: "",
          fileUpload: [],
          flagUpdate: false
        },
        team: 0,
        appointmentDate: "",
        serviceDate: "",
        cost: 0,
        price: 0,
        planStatus: 0,
        planJobId: 0,
        statusDetail: ""
      },
      equipmentOffered: {
        fields: [
          {
            key: 'select',
            label: ''
          },
          {
            key: 'text',
            label: 'รายการ'
          },
          {
            key: 'cost',
            label: 'ราคาทุน'
          },
          {
            key: 'amount',
            label: 'จำนวน'
          },
          {
            key: 'totalCost',
            label: 'ราคาทุนรวม'
          },
          {
            key: 'price',
            label: 'ราคาขาย'
          },
          {
            key: 'action',
            label: 'ดำเนินการ'
          }
        ],
        items: [],
        totalCost: 0,
        totalPrice: 0,
        discount: 0,
        netTotal: 0,
      },
      equipmentCreateForm: {
        equipmentIdEdit: "",
        equipmentText: "",
        equipmentCost: "",
        equipmentAmount: "",
        equipmentTotalCost: "",
        equipmentPrice: "",
      },
      companyCreateForm: {
        companyName: "",
        address: "",
        address2: "",
        subDistrict: "",
        district: "",
        province: "",
        postCode: "",
        taxId: "",
      },
      buildingCreateForm: {
        buildingName: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        locationUrl: "",
        companyData: ""
      },
      contactCreateForm: {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
      },
      masterFormData: {
        companyData: [],
        buildingData: [],
        contactData: []
      },
      selBuildingId: "",
      selCompanyId: "",
      selContactId: "",
      dropzoneOptions: {
        url: 'https://your-upload-endpoint.com/upload',
        acceptedFiles: 'image/*,.pdf',
        maxFilesize: 10,
        addRemoveLinks: true,
        dictDefaultMessage: `<i class="fas fa-upload fa-5x"></i>`,
        autoProcessQueue: false
      },
      formImagesMaster: [],
      formDocMaster: [],
      formImages: [],
      formDoc: [],
      formImages_2: [],
      formDoc_2: [],
      formImages_3: [],
      formDoc_3: [],
      formImages_4: [],
      formDoc_4: [],
      dropzoneStage: 'edit',
      dropzoneStageBtn: 'editOpen',
      listRefDropzone: {
        "editNew": "editDropzone",
        "editNew_2": "editDropzone2",
        "editNew_3": "editDropzone3",
        "editNew_4": "editDropzone4"
      },
      tabIndex: 0,
      showTabImgDoc: false,
      tableImgDocItem: {
        fields: [
          {
            key: 'ex',
            label: 'ภาพตัวอย่าง'
          },
          {
            key: 'action',
            label: 'ดำเนินการ'
          }
        ],
        items: []
      },
      equipmentState: '',
      tableKey: 0,
      selectMode: "multi"
    };
  },
  created() {
    if (ThaiTambons) {
      this.formSetting.subDistrict = ThaiTambons.RECORDS.map(e => {
        return {
          value: e.name_th,
          text: e.name_th
        }
      })
    }

    if (ThaiAmphures) {
      this.formSetting.district = ThaiAmphures.RECORDS.map(e => {
        return {
          value: e.name_th,
          text: e.name_th
        }
      })
    }

    if (ThaiProvinces) {
      this.formSetting.province = ThaiProvinces.RECORDS.map(e => {
        return {
          value: e.name_th,
          text: e.name_th
        }
      })
    }
  },
  mounted() {
    this.pageInit()
    this.setEventListener()
  },
  methods: {
    pageInit() {

      this.getCompanyData()
      this.getBuildingData()
      this.getContact()
      this.getTeam()

      $('.custom-select2').select2({
        theme: 'bootstrap4',
      });

      const that = this
      const paramsPlanId = this.$route.params.id;
      if (paramsPlanId) {
        this.paramsPlanId = paramsPlanId
        setTimeout(() => {
          that.getPlanById()
        }, 500)
      }

    },
    setEventListener() {
      const that = this
      $('#form_sel_building_name').on('select2:select', function (e) {
        that.sortBuilding(e.params.data.id)
        that.selBuildingId = e.params.data.id
      });
      $('#form_sel_company').on('select2:select', function (e) {
        that.sortCompany(e.params.data.id)
        that.selCompanyId = e.params.data.id
      });
      $('#form_sel_contact').on('select2:select', function (e) {
        that.sortContact(e.params.data.id)
        that.selContactId = e.params.data.id
      });
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    toggleModal() {
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    companyActionModal() {
      this.clearCompanyForm()
      this.$refs["companyActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    buildingActionModal() {
      this.clearBuildingForm()
      this.$refs["buildingActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    contactActionModal() {
      this.clearContactForm()
      this.$refs["contactActionModal"].show();
      setTimeout(() => {
        $('.custom-select2').select2({
          theme: 'bootstrap4',
        });
      }, 100)
    },
    equipmentActionAdd() {
      this.equipmentCreateForm.equipmentText = ""
      this.equipmentCreateForm.equipmentIdEdit = ""
      this.$refs["equipmentActionModal"].show();
    },
    equipmentActionEdit(tableIndex) {
      // console.log("equipmentActionEdit", tableIndex)
      const textEquipment = this.equipmentOffered.items.find((e, index) => {
        if (index == tableIndex.index) {
          return e
        }
      })
      this.equipmentCreateForm.equipmentText = textEquipment.text
      this.equipmentCreateForm.equipmentCost = textEquipment.cost
      this.equipmentCreateForm.equipmentAmount = textEquipment.amount
      this.equipmentCreateForm.equipmentTotalCost = textEquipment.totalCost
      this.equipmentCreateForm.equipmentPrice = textEquipment.price
      this.equipmentCreateForm.equipmentIdEdit = tableIndex.index
      this.$refs["equipmentActionModal"].show();
    },
    equipmentActionDelete(tableIndex) {
      this.equipmentOffered.items.splice(tableIndex.index, 1);
    },
    equipmentActionSelect(tableIndex) {
      let id = tableIndex?.index
      let eqOff = this.equipmentOffered.items[id]
      let items = this.equipmentOffered.items
      this.equipmentOffered.items = []
      let nowStage = eqOff?.selected
      let newObj = {
        ...eqOff,
        selected: (nowStage) ? false : true
      }
      items[id] = newObj
      this.equipmentActionHandle(items)

    },
    equipmentActionHandle(items) {
      this.equipmentOffered.items = items
    },
    formJobInvoiceSave(mode) {
      if (mode != "edit") {
        if ($("#ck_new_date_invoice")[0].checked) {
          this.formJobStatus.invoice.date = moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.formJobStatus.invoice.date = this.formJobStatus.invoice.tempDate || moment().format('YYYY-MM-DD HH:mm:ss')
        }
        this.formJobStatus.invoice.flagUpdate = true
      } else {
        this.formJobStatus.invoice.tempDate = this.formJobStatus.invoice.date
        this.formJobStatus.invoice.date = ""
        this.formJobStatus.invoice.flagUpdate = false
      }

    },
    formJobApprovalSave(mode) {
      if (mode != "edit") {

        if ($("#ck_new_date_approval")[0].checked) {
          this.formJobStatus.approval.date = moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.formJobStatus.approval.date = this.formJobStatus.approval.tempDate || moment().format('YYYY-MM-DD HH:mm:ss')
        }
        this.formJobStatus.approval.flagUpdate = true
      } else {
        this.formJobStatus.approval.tempDate = this.formJobStatus.approval.date
        this.formJobStatus.approval.date = ""
        this.formJobStatus.approval.flagUpdate = false
      }
    },
    formJobPartsSave(mode) {
      if (mode != "edit") {

        if ($("#ck_new_date_parts")[0].checked) {
          this.formJobStatus.parts.date = moment().format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.formJobStatus.parts.date = this.formJobStatus.parts.tempDate || moment().format('YYYY-MM-DD HH:mm:ss')
        }
        this.formJobStatus.parts.flagUpdate = true
      } else {
        this.formJobStatus.parts.tempDate = this.formJobStatus.parts.date
        this.formJobStatus.parts.date = ""
        this.formJobStatus.parts.flagUpdate = false
      }
    },
    formPlanSave() {
      Swal.fire({
        title: 'ยืนยันการบันทึก ?',
        text: "คุณยืนยันการบันทึกแผนงาน ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.checkFilesUploads()
          // this.sendPlanSave()
        }
      })
    },
    sendPlanSave() {

      let cData = this.masterFormData.companyData.find(e => {
        return e._id === this.selCompanyId
      })

      let bData = this.masterFormData.buildingData.find(e => {
        return e._id === this.selBuildingId
      })

      let coData = this.masterFormData.contactData.find(e => {
        return e._id === this.selContactId
      })

      let sendBody = JSON.stringify({
        createDate: moment(this.form.createDate).format('YYYY-MM-DD HH:mm:ss'),
        jobType: $('#form_sel_jobType').val(),
        companyId: cData?._id,
        companyName: cData?.name,
        address: this.form.address,
        address2: this.form.address2,
        subDistrict: $('#form_subDistrict').val(),
        district: $('#form_district').val(),
        province: $('#form_province').val(),
        postCode: this.form.postCode,
        taxId: this.form.taxId,
        buildingId: bData?._id,
        buildingName: bData?.name,
        brandName: this.form.brandName,
        numberOfElevator: this.form.numberOfElevator,
        numberOfFloors: this.form.numberOfFloors,
        locationUrl: this.form.locationUrl,
        contactId: coData?._id,
        contactName: coData?.name,
        phoneNumber: this.form.contactPhone,
        email: this.form.contactEmail,
        detail: this.form.detail,
        equipmentOffered: this.equipmentOffered.items,
        equipmentOfferedDiscount: this.equipmentOffered?.discount,
        files: this.form.files,
        invoice: {
          date: this.formJobStatus.invoice.detail ? moment().format("YYYY-MM-DD HH:mm:ss") : "",
          detail: this.formJobStatus.invoice.detail,
          files: this.form.files2
        },
        approval: {
          date: this.formJobStatus.approval.detail ? moment().format("YYYY-MM-DD HH:mm:ss") : "",
          detail: this.formJobStatus.approval.detail,
          files: this.form.files3
        },
        parts: {
          date: this.formJobStatus.parts.detail ? moment().format("YYYY-MM-DD HH:mm:ss") : "",
          detail: this.formJobStatus.parts.detail,
          files: this.form.files4
        },
        team: $('#form_sel_team').val(),
        serviceDate: this.formJobStatus.serviceDate,
        appointmentDate: this.formJobStatus.appointmentDate,
        statusDetail: this.formJobStatus.statusDetail,
        planStatus: this.formJobStatus.planStatus
      })

      FetchService.post("/addplans", sendBody, res => {
        Swal.fire({
          title: 'สำเร็จ',
          html: 'แผนของคุณบันทึกเรียบร้อยแล้ว',
          icon: 'success',
          timer: 1000,
        }).then((result) => {
          this.$router.push('/PlansTable')
          // console.log(result)
        })
      })

    },
    addEquipment() {

      let emtryObj = {
        equipmentIdEdit: "",
        equipmentText: "",
        equipmentCost: "",
        equipmentAmount: "",
        equipmentTotalCost: "",
        equipmentPrice: "",
      }

      if (this.equipmentCreateForm.equipmentText) {

        let create = this.equipmentCreateForm
        let id = create.equipmentIdEdit
        let eqOff = this.equipmentOffered

        if (create.equipmentIdEdit !== "") {

          eqOff.items[id].text = create.equipmentText
          eqOff.items[id].cost = create.equipmentCost
          eqOff.items[id].amount = create.equipmentAmount
          eqOff.items[id].totalCost = create.equipmentTotalCost
          eqOff.items[id].price = create.equipmentPrice

          this.equipmentCreateForm = emtryObj
          this.equipmentOffered = eqOff

        } else {

          let create = this.equipmentCreateForm
          this.equipmentOffered.items.push({
            text: create.equipmentText,
            cost: create.equipmentCost,
            amount: create.equipmentAmount,
            totalCost: create.equipmentTotalCost,
            price: create.equipmentPrice,
            selected: false
          })

          this.equipmentCreateForm = emtryObj

        }

        this.$refs["equipmentActionModal"].hide();

      }
    },
    getCompanyData() {
      FetchService.get("/getcompany", (response) => {
        if (response) {
          // console.log("getcompany", response)
          response = JSON.parse(response)
          this.masterFormData.companyData = response.allCompany
          this.formSetting.companyData = response.allCompany.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    getBuildingData() {
      FetchService.get("/getbuilding", (response) => {
        if (response) {
          response = JSON.parse(response)
          // console.log("getbuilding", response)
          this.masterFormData.buildingData = response.thisBuilding
          this.formSetting.buildingData = response.thisBuilding.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    getContact() {
      FetchService.get("/getcontact", (response) => {
        if (response) {
          response = JSON.parse(response)
          // console.log("getcontact", response)
          this.masterFormData.contactData = response.thisContact
          this.formSetting.contactData = response.thisContact.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    getTeam() {
      FetchService.get("/getteam", (response) => {
        if (response) {
          response = JSON.parse(response)
          // console.log("getteam", response)
          this.masterFormData.teamData = response.thisTeam
          this.formSetting.teamData = response.thisTeam.map(e => {
            return {
              value: e._id,
              text: e.name
            }
          })
        }
      })
    },
    resetForm() {
      this.form = {
        createDate: "",
        jobType: 0,
        companyData: 0,
        address: "",
        address2: "",
        subDistrict: 0,
        district: 0,
        province: 0,
        postCode: "",
        taxId: "",
        locationUrl: "",
        buildingData: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        detail: "",
        equipmentOffered: [],
        contactName: "",
        contactPhone: "",
        contactEmail: "",
        files: []
      }

      this.equipmentOffered.items = []
    },
    getPlanById() {
      FetchService.get("/selectplans/" + this.paramsPlanId, (response) => {
        if (response) {
          let res = JSON.parse(response)
          this.planByIdData = res.thisPlans
          console.log("🚀 ~ FetchService.get ~ this.planByIdData:", this.planByIdData)
          if (this.planByIdData) {
            this.showPlanById()
          }
        }
      })
    },
    showPlanById() {

      this.pageStage = 'update'

      this.formJobStatus.invoice = {
        detail: this.planByIdData.invoice.detail,
        date: this.planByIdData.invoice.date ? moment(this.planByIdData.invoice.date).format("YYYY-MM-DD HH:mm:ss") : "",
        fileUpload: this.planByIdData.invoice.fileUpload,
        flagUpdate: this.planByIdData.invoice.date ? true : false
      }
      this.formJobStatus.approval = {
        detail: this.planByIdData.approval.detail,
        date: this.planByIdData.approval.date ? moment(this.planByIdData.approval.date).format("YYYY-MM-DD HH:mm:ss") : "",
        fileUpload: this.planByIdData.approval.fileUpload,
        flagUpdate: this.planByIdData.approval.date ? true : false
      }
      this.formJobStatus.parts = {
        detail: this.planByIdData.parts.detail,
        date: this.planByIdData.parts.date ? moment(this.planByIdData.parts.date).format("YYYY-MM-DD HH:mm:ss") : "",
        fileUpload: this.planByIdData.parts.fileUpload,
        flagUpdate: this.planByIdData.parts.date ? true : false
      }

      this.formJobStatus.team = this.planByIdData.teamID
      this.formJobStatus.appointmentDate = this.planByIdData.appointmentDate ? new Date(this.planByIdData.appointmentDate) : ""
      this.formJobStatus.serviceDate = this.planByIdData.serviceDate ? new Date(this.planByIdData.serviceDate) : ""
      // this.formJobStatus.cost = this.planByIdData.cost
      // this.formJobStatus.price = this.planByIdData.price
      this.formJobStatus.statusDetail = this.planByIdData.statusDetail
      this.formJobStatus.planStatus = this.planByIdData.planStatus

      this.form.createDate = new Date(this.planByIdData.create_date)
      this.form.jobType = this.planByIdData.event_type

      this.sortCompany(this.planByIdData, 3)
      this.sortBuilding(this.planByIdData, 3)
      this.sortContact(this.planByIdData, 3)
      this.sortTeam(this.planByIdData, 3)

      this.form.detail = this.planByIdData.details

      this.equipmentOffered.items = this.planByIdData.equipment
      this.equipmentOffered.discount = this.planByIdData?.equipmentDiscount

      const formImages = this.planByIdData.image.fileNames.filter(e => { return e.type != "application/pdf" })
      const formDoc = this.planByIdData.image.fileNames.filter(e => { return e.type == "application/pdf" })
      const formImages_2 = this.planByIdData.invoice.fileNames.filter(e => { return e.type != "application/pdf" })
      const formDoc_2 = this.planByIdData.invoice.fileNames.filter(e => { return e.type == "application/pdf" })
      const formImages_3 = this.planByIdData.approval.fileNames.filter(e => { return e.type != "application/pdf" })
      const formDoc_3 = this.planByIdData.approval.fileNames.filter(e => { return e.type == "application/pdf" })
      const formImages_4 = this.planByIdData.parts.fileNames.filter(e => { return e.type != "application/pdf" })
      const formDoc_4 = this.planByIdData.parts.fileNames.filter(e => { return e.type == "application/pdf" })

      this.formImagesMaster = formImages
      this.formDocMaster = formDoc

      this.formImages = formImages.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/img/' + e.name
        }
      })

      this.formDoc = formDoc.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/img/' + e.name
        }
      })

      this.formImages_2 = formImages_2.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/invoice/' + e.name
        }
      })

      this.formDoc_2 = formDoc_2.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/invoice/' + e.name
        }
      })

      this.formImages_3 = formImages_3.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/approval/' + e.name
        }
      })

      this.formDoc_3 = formDoc_3.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/approval/' + e.name
        }
      })

      this.formImages_4 = formImages_4.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/parts/' + e.name
        }
      })

      this.formDoc_4 = formDoc_4.map(e => {
        return {
          name: e.name,
          url: this.baseUrl + '/parts/' + e.name
        }
      })

      this.showTabImgDoc = true

    },
    formJobStatusSave() {
      Swal.fire({
        title: 'ยืนยันการบันทึก ?',
        text: "คุณยืนยันการบันทึกแผนงาน ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendJobStatus()
        }
      })
    },
    sendJobStatus() {

      let raw = JSON.stringify({
        "invoice": {
          "date": this.formJobStatus.invoice.date ? moment(this.formJobStatus.invoice.date).format("YYYY-MM-DD HH:mm:ss") : "",
          "detail": this.formJobStatus.invoice.date ? this.formJobStatus.invoice.detail : "",
          "fileUpload": []
        },
        "approval": {
          "date": this.formJobStatus.approval.date ? moment(this.formJobStatus.approval.date).format("YYYY-MM-DD HH:mm:ss") : "",
          "detail": this.formJobStatus.approval.date ? this.formJobStatus.approval.detail : "",
          "fileUpload": []
        },
        "parts": {
          "date": this.formJobStatus.parts.date ? moment(this.formJobStatus.parts.date).format("YYYY-MM-DD HH:mm:ss") : "",
          "detail": this.formJobStatus.parts.date ? this.formJobStatus.parts.detail : "",
          "fileUpload": []
        },
        "team": $('#form_sel_team').val(),
        "appointmentDate": this.formJobStatus.appointmentDate ? moment(this.formJobStatus.appointmentDate).format("YYYY-MM-DD HH:mm:ss") : "",
        "serviceDate": this.formJobStatus.serviceDate ? moment(this.formJobStatus.serviceDate).format("YYYY-MM-DD HH:mm:ss") : "",
        "planStatus": this.formJobStatus.planStatus,
        "statusDetail": this.formJobStatus.statusDetail
      });

      FetchService.post("/editplans/" + this.planByIdData._id, raw, res => {
        // console.log(res)

        Swal.fire(
          'สำเร็จ',
          'แผนของคุณบันทึกเรียบร้อยแล้ว',
          'success'
        )

      })
    },
    addCompany() {

      var raw = JSON.stringify({
        "companyName": this.companyCreateForm.companyName,
        "address": this.companyCreateForm.address,
        "address2": this.companyCreateForm.address2,
        "subDistrict": $('#companyCreateForm_subDistrict').val(),
        "district": $('#companyCreateForm_district').val(),
        "province": $('#companyCreateForm_province').val(),
        "postCode": this.companyCreateForm.postCode,
        "taxId": this.companyCreateForm.taxId
      });

      this.clearCompanyForm()

      FetchService.post("/addcompany", raw, res => {
        // console.log(res)

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )

        this.getCompanyData()
        this.$refs["companyActionModal"].hide()
      })

    },
    addBuilding() {

      var raw = JSON.stringify({
        "buildingName": this.buildingCreateForm.buildingName,
        "brandName": this.buildingCreateForm.brandName,
        "numberOfElevator": this.buildingCreateForm.numberOfElevator,
        "numberOfFloors": this.buildingCreateForm.numberOfFloors,
        "locationUrl": this.buildingCreateForm.locationUrl,
      });

      let set = $('#buildingCreateForm_companyData').val()
      this.clearCompanyForm()
      FetchService.post("/addbuilding/" + set, raw, res => {
        // console.log(res)

        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )

        this.getBuildingData()
        this.$refs["buildingActionModal"].hide()
      })

    },
    addContact() {
      var raw = JSON.stringify({
        "contactName": this.contactCreateForm.contactName,
        "contactPhone": this.contactCreateForm.contactPhone,
        "contactEmail": this.contactCreateForm.contactEmail,
      });

      this.clearContactForm()
      let set = $('#contactCreateForm_companyData').val()
      FetchService.post("/addcontact/" + set, raw, res => {
        // console.log(res)
        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )
        this.getContact()
        this.$refs["contactActionModal"].hide()
      })
    },
    sortBuilding(sel, mode) {
      if (mode == 3) {
        let t = sel.detail_company
        this.selBuildingId = sel.building_ID
        this.form.buildingData = sel.building_ID
        this.form.brandName = t.brandName
        this.form.numberOfElevator = t.numberOfElevator
        this.form.numberOfFloors = t.numberOfFloors
        this.form.locationUrl = t.locationUrl

        setTimeout(() => {
          $('.custom-select2').select2({
            theme: 'bootstrap4',
          });
        }, 500)

      } else {
        let t = this.masterFormData.buildingData.find(e => {
          if ((e.name === sel) || e._id === sel) {
            return e
          }
        })
        // console.log("sortBuilding", t)
        if (t) {
          this.form.buildingData = mode == 1 ? t._id : t.name
          this.form.brandName = t.brandName
          this.form.numberOfElevator = t.numberOfElevator
          this.form.numberOfFloors = t.numberOfFloors
          this.form.locationUrl = t.locationUrl
        }
      }

    },
    sortCompany(sel, mode) {
      if (mode == 3) {
        let t = sel.detail_company
        this.selCompanyId = sel.company_ID
        this.form.companyData = sel.company_ID
        this.form.address = t.address
        this.form.address2 = t.address2

        let sd = t.subDistrict?.trim()
        this.form.subDistrict = sd

        let d = t.district?.trim()
        d = t.province == "กรุงเทพมหานคร" ? d.startsWith("เขต") ? d : "เขต" + d : d
        this.form.district = d
        this.form.province = t.province
        this.form.postCode = t.postCode
        this.form.taxId = t.taxId

        setTimeout(() => {
          $('.custom-select2').select2({
            theme: 'bootstrap4',
          });
        }, 500)

      } else {
        sel = sel?.trim()
        // console.log(sel)
        let t = this.masterFormData.companyData.find(e => {
          if ((e.name === sel) || (e._id === sel)) {
            return e
          }
        })
        // console.log("sortCompany", t)
        if (t) {
          this.form.companyData = t._id
          this.form.address = t.address
          this.form.address2 = t.address2

          let sd = t.subDistrict?.trim()
          this.form.subDistrict = sd

          let d = t.district?.trim()
          d = t.province == "กรุงเทพมหานคร" ? d.startsWith("เขต") ? d : "เขต" + d : d
          this.form.district = d
          this.form.province = t.province
          this.form.postCode = t.postCode
          this.form.taxId = t.taxId
          $('#form_sel_company').val(t._id).trigger('change');
          $('#form_subDistrict').val(sd).trigger('change');
          $('#form_district').val(d).trigger('change');
          $('#form_province').val(t.province).trigger('change');

          if (mode == 1) {
            // <---- builing ---->
            let buildingData = this.masterFormData.buildingData.filter(e => {
              return (e.company_id == t._id) || (e.company_id == t.taxId)
            })

            if (buildingData?.length > 0) {
              buildingData = buildingData.map(e => {
                return {
                  value: e._id,
                  text: e.name
                }
              })

              // console.log("buildingData", buildingData)
              let newOption = buildingData.map(e => {
                return new Option(e.text, e.value, false, false);
              })
              $('#form_sel_building_name').empty()
              $('#form_sel_building_name').append(newOption).trigger('change');
              this.sortBuilding(buildingData[0].text)
            }


            // <---- contact ---->
            let contactData = this.masterFormData.contactData.filter(e => {
              return (e.company_id == t._id) || (e.company_id == t.taxId)
            })

            if (contactData?.length > 0) {
              contactData = contactData.map(e => {
                return {
                  value: e._id,
                  text: e.name
                }
              })
              let newOption2 = contactData.map((e, index) => {
                return new Option(e.text, e.value, true, index == 0 ? true : false);
              })
              $('#form_sel_contact').empty()
              $('#form_sel_contact').append(newOption2).trigger('change');
              this.sortContact(contactData[0].text)
            }
          }
        }
      }

    },
    sortContact(sel, mode) {
      // console.log("sortContact", sel)
      if (mode == 3) {
        let t = sel.detail_company
        this.selContactId = sel.contact_ID
        this.form.contactName = sel.contact_ID
        this.form.contactPhone = t.phoneNumber
        this.form.contactEmail = t.email
        setTimeout(() => {
          $('.custom-select2').select2({
            theme: 'bootstrap4',
          });
        }, 500)

      } else {

        let t = this.masterFormData.contactData.find(e => {
          if (e._id === sel) {
            return e
          }
        })

        if (t) {
          this.form.contactName = t._id
          this.form.contactPhone = t.phoneNumber
          this.form.contactEmail = t.email
        }

      }

    },
    sortTeam(sel, mode) {
      if (mode == 3) {
        this.formJobStatus.team = sel.teamID
        setTimeout(() => {
          $('.custom-select2').select2({
            theme: 'bootstrap4',
          });
        }, 500)

      }
    },
    findString(text, searchString) {
      let occurrences = [];
      let startIndex = 0;

      while (true) {
        const index = text.indexOf(searchString, startIndex);
        if (index === -1) {  // String not found anymore
          break;
        }
        occurrences.push(index);
        startIndex = index + 1;
      }

      return occurrences;
    },
    clearCompanyForm() {
      this.companyCreateForm = {
        companyName: "",
        address: "",
        address2: "",
        subDistrict: "",
        district: "",
        province: "",
        postCode: "",
        taxId: "",
      }
    },
    confirmActionCompany() {
      if (this.companyCreateForm.companyName == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่อบริษัท',
          'error'
        )
      } else {
        Swal.fire({
          title: 'ยืนยันการบันทึก ?',
          text: "คุณยืนยันการบันทึกบริษัท ใช่หรือไม่",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3699FE',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.isConfirmed) {
            this.addCompany()
          }
        })
      }
    },
    clearBuildingForm() {
      this.buildingCreateForm = {
        buildingName: "",
        brandName: "",
        numberOfElevator: 0,
        numberOfFloors: 0,
        locationUrl: "",
        companyData: ""
      }
    },
    confirmActionBuilding() {
      if (this.buildingCreateForm.buildingName == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่ออาคาร',
          'error'
        )
      } else {
        Swal.fire({
          title: 'ยืนยันการบันทึก ?',
          text: "คุณยืนยันการบันทึกอาคาร ใช่หรือไม่",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3699FE',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.isConfirmed) {
            this.addBuilding()
          }
        })
      }
    },
    clearContactForm() {
      this.contactCreateForm = {
        contactName: "",
        contactPhone: "",
        contactEmail: "",
      }
    },
    confirmActionContact() {
      if (this.contactCreateForm.contactName == "") {
        Swal.fire(
          'มีข้อผิดพลาด',
          'กรุณาระบุชื่ออาคาร',
          'error'
        )
      } else {
        Swal.fire({
          title: 'ยืนยันการบันทึก ?',
          text: "คุณยืนยันการบันทึกผู้ติดต่อ ใช่หรือไม่",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3699FE',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.isConfirmed) {
            this.addContact()
          }
        })
      }
    },
    formPlanUpdate() {
      Swal.fire({
        title: 'ยืนยันการแก้ไข ?',
        text: "คุณยืนยันการแก้ไขแผนงาน ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendPlanEdit()
        }
      })
    },
    sendPlanEdit() {

      let cData = this.masterFormData.companyData.find(e => {
        return e._id === this.selCompanyId
      })

      let bData = this.masterFormData.buildingData.find(e => {
        return e._id === this.selBuildingId
      })

      let coData = this.masterFormData.contactData.find(e => {
        return e._id === this.selContactId
      })

      let sendBody = JSON.stringify({
        "invoice": {
          "date": this.formJobStatus.invoice.date ? moment(this.formJobStatus.invoice.date).format("YYYY-MM-DD HH:mm:ss") : "",
          "detail": this.formJobStatus.invoice.date ? this.formJobStatus.invoice.detail : "",
          "fileUpload": []
        },
        "approval": {
          "date": this.formJobStatus.approval.date ? moment(this.formJobStatus.approval.date).format("YYYY-MM-DD HH:mm:ss") : "",
          "detail": this.formJobStatus.approval.date ? this.formJobStatus.approval.detail : "",
          "fileUpload": []
        },
        "parts": {
          "date": this.formJobStatus.parts.date ? moment(this.formJobStatus.parts.date).format("YYYY-MM-DD HH:mm:ss") : "",
          "detail": this.formJobStatus.parts.date ? this.formJobStatus.parts.detail : "",
          "fileUpload": []
        },
        "team": $('#form_sel_team').val(),
        "appointmentDate": this.formJobStatus.appointmentDate ? moment(this.formJobStatus.appointmentDate).format("YYYY-MM-DD HH:mm:ss") : "",
        "serviceDate": this.formJobStatus.serviceDate ? moment(this.formJobStatus.serviceDate).format("YYYY-MM-DD HH:mm:ss") : "",
        // "cost": this.formJobStatus.cost,
        // "price": this.formJobStatus.price,
        "planStatus": this.formJobStatus.planStatus,
        "createDate": moment(this.form.createDate).format('YYYY-MM-DD HH:mm:ss'),
        "jobType": $('#form_sel_jobType').val(),
        "companyId": cData?._id,
        "companyName": cData?.name,
        address: this.form.address,
        address2: this.form.address2,
        subDistrict: $('#form_subDistrict').val(),
        district: $('#form_district').val(),
        province: $('#form_province').val(),
        postCode: this.form.postCode,
        taxId: this.form.taxId,
        "buildingId": bData?._id,
        buildingName: bData?.name,
        brandName: this.form.brandName,
        numberOfElevator: this.form.numberOfElevator,
        numberOfFloors: this.form.numberOfFloors,
        "locationUrl": this.form.locationUrl,
        "contactId": coData?._id,
        contactName: coData?.name,
        phoneNumber: this.form.contactPhone,
        email: this.form.contactEmail,
        "detail": this.form.detail,
        "equipmentOffered": this.equipmentOffered.items,
        "equipmentOfferedDiscount": this.equipmentOffered?.discount,
      })

      // console.log(sendBody)

      FetchService.post("/editplans/" + this.paramsPlanId, sendBody, res => {
        Swal.fire({
          title: 'สำเร็จ',
          html: 'แผนของคุณบันทึกเรียบร้อยแล้ว',
          icon: 'success',
          timer: 1000,
        }).then((result) => {
          this.$router.push('/PlansTable')
        })
      })

    },
    formPlanDel() {
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบแผนงาน ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendPlanDel()
        }
      })
    },
    sendPlanDel() {
      FetchService.get("/deleteplans/" + this.paramsPlanId, (response) => {
        Swal.fire({
          title: 'สำเร็จ',
          html: 'แผนของคุณลบเรียบร้อยแล้ว',
          icon: 'success',
          timer: 1000,
        }).then((result) => {
          this.$router.push('/PlansTable')
        })
      })
    },
    dataURLtoBlob(dataurl) {
      let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    checkFilesUploads() {
      let files = []
      files = this.$refs.myVueDropzone.getAcceptedFiles();
      if (files.length > 0) {
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          if (files[i].type == "application/pdf") {
            formData.append('file_upload_plan', files[i]);
          } else {
            const blob = this.dataURLtoBlob(files[i].dataURL);
            formData.append('file_upload_plan', blob, files[i].name);
          }
        }

        let that = this
        FetchService.post("/upload/multiple/plan", formData, res => {
          res = JSON.parse(res)
          if (res?.uploadedFiles) {
            that.form.files = res.uploadedFiles.map(e => {
              return {
                filename: e.name,
                size: e.size
              }
            })
          }
          that.checkFilesUploads2()
        }, {})
      } else {
        this.checkFilesUploads2()
      }
    },
    checkFilesUploads2() {
      let files = []
      files = this.$refs.myVueDropzone2.getAcceptedFiles();
      if (files.length > 0) {
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          if (files[i].type == "application/pdf") {
            formData.append('file_upload_invoice', files[i]);
          } else {
            const blob = this.dataURLtoBlob(files[i].dataURL);
            formData.append('file_upload_invoice', blob, files[i].name);
          }
        }

        let that = this
        FetchService.post("/upload/multiple/invoice", formData, res => {
          res = JSON.parse(res)
          if (res?.uploadedFiles) {
            that.form.files2 = res.uploadedFiles.map(e => {
              return {
                filename: e.name,
                size: e.size
              }
            })
          }
          that.checkFilesUploads3()
        }, {})
      } else {
        this.checkFilesUploads3()
      }
    },
    checkFilesUploads3() {
      let files = []
      files = this.$refs.myVueDropzone3.getAcceptedFiles();
      if (files.length > 0) {
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          if (files[i].type == "application/pdf") {
            formData.append('file_upload_approval', files[i]);
          } else {
            const blob = this.dataURLtoBlob(files[i].dataURL);
            formData.append('file_upload_approval', blob, files[i].name);
          }
        }

        let that = this
        FetchService.post("/upload/multiple/approval", formData, res => {
          res = JSON.parse(res)
          if (res?.uploadedFiles) {
            that.form.files3 = res.uploadedFiles.map(e => {
              return {
                filename: e.name,
                size: e.size
              }
            })
          }
          that.checkFilesUploads4()
        }, {})
      } else {
        this.checkFilesUploads4()
      }
    },
    checkFilesUploads4() {
      let files = []
      files = this.$refs.myVueDropzone4.getAcceptedFiles();
      if (files.length > 0) {
        let formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          if (files[i].type == "application/pdf") {
            formData.append('file_upload_parts', files[i]);
          } else {
            const blob = this.dataURLtoBlob(files[i].dataURL);
            formData.append('file_upload_parts', blob, files[i].name);
          }
        }

        let that = this
        FetchService.post("/upload/multiple/parts", formData, res => {
          res = JSON.parse(res)
          if (res?.uploadedFiles) {
            that.form.files4 = res.uploadedFiles.map(e => {
              return {
                filename: e.name,
                size: e.size
              }
            })
          }
          that.sendPlanSave()
        }, {})
      } else {
        this.sendPlanSave()
      }
    },
    formEditImgDoc() {

      this.showTabImgDoc = false
      this.dropzoneStageBtn = 'editSave'

      if (this.dropzoneStage == 'edit') {
        this.dropzoneStage = 'editNew'
      }

      let imageNew, docNew

      if (this.tabIndex == 0) {
        imageNew = this.formImages.map(e => {
          return {
            type: 'image',
            data: e
          }
        })

        docNew = this.formDoc.map(e => {
          return {
            type: 'doc',
            data: e
          }
        })
      } else if (this.tabIndex == 1) {
        imageNew = this.formImages_2.map(e => {
          return {
            type: 'image',
            data: e
          }
        })

        docNew = this.formDoc_2.map(e => {
          return {
            type: 'doc',
            data: e
          }
        })
      } else if (this.tabIndex == 2) {
        imageNew = this.formImages_3.map(e => {
          return {
            type: 'image',
            data: e
          }
        })

        docNew = this.formDoc_3.map(e => {
          return {
            type: 'doc',
            data: e
          }
        })
      } else {
        imageNew = this.formImages_4.map(e => {
          return {
            type: 'image',
            data: e
          }
        })

        docNew = this.formDoc_4.map(e => {
          return {
            type: 'doc',
            data: e
          }
        })
      }

      this.tableImgDocItem.items = [...imageNew, ...docNew]

      // for dropzone

      // let nowStage = ''
      // if (this.dropzoneStage == 'edit') {
      //   this.dropzoneStage = 'editNew'
      //   nowStage = 'editNew'
      // } else {
      //   nowStage = this.dropzoneStage
      // }


      // setTimeout(() => {
      //   const that = this
      //   const refName = that.listRefDropzone[that.dropzoneStage]
      //   if (nowStage == "editNew") {

      //     that.formImagesMaster.forEach((file, index) => {
      //       const mockFile = { name: file.name, size: file.size };
      //       that.$refs[refName].manuallyAddFile(mockFile, that.formImages[index]);
      //     });

      //     that.formDocMaster.forEach((file, index) => {
      //       const mockFile = { name: file.name, size: file.size };
      //       that.$refs[refName].manuallyAddFile(mockFile, that.formDoc[index]);
      //     });

      //   } else if (nowStage == "editNew_2") {
      //     that.$refs[refName].manuallyAddFile(mockFile, that.formImages_2[index]);
      //   } else if (nowStage == "editNew_3") {
      //     that.$refs[refName].manuallyAddFile(mockFile, that.formImages_3[index]);
      //   } else if (nowStage == "editNew_4") {
      //     that.$refs[refName].manuallyAddFile(mockFile, that.formImages_4[index]);
      //   }

      // }, 100)

    },
    formEditImgDocSave() {
      if (this.dropzoneStage == "editNew") {
        this.checkFilesUploads()
        // console.log(this.planByIdData)
        // let sendBody = {
        //   files: this.form.files
        // } 
        // FetchService.post("/editUploadplans/" + this.planByIdData['_id'], sendBody, res => {
        //   console.log(res)
        // })
      } else if (this.dropzoneStage == "editNew_2") {
      } else if (this.dropzoneStage == "editNew_3") {
      } else if (this.dropzoneStage == "editNew_4") {
      }

      this.dropzoneStage = 'edit'
      this.dropzoneStageBtn = 'editSave'

    },
    formEditImgDocCancel() {
      this.showTabImgDoc = true
      this.dropzoneStage = 'edit'
      this.dropzoneStageBtn = 'editOpen'

    },
    handleDropzoneStage(stage) {
      this.dropzoneStage = stage
    },
    openModalDropzone() {
      this.$refs["uploadsImgDocModal"].show();
    },
    confirmTableImgDocItemDelete(data) {
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบ ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.tableImgDocItemDelete(data)
        }
      })
    },
    tableImgDocItemDelete(data) {
      let that = this
      const fileName = data?.item?.data?.name
      if (fileName) {
        let pathFile = ""
        if (this.tabIndex == 1) {
          pathFile = "/invoice"
        } else if (this.tabIndex == 2) {
          pathFile = "/approval"
        } else if (this.tabIndex == 3) {
          pathFile = "/parts"
        }
        FetchService.get(`/deleteimageplan${pathFile}/${this.planByIdData.planJobID}/${fileName}`, (response) => {
          if (response) {
            that.getPlanById()
            that.formEditImgDocCancel()
          }
        })
      }
    },
    confirmUploadsImgDocInModal() {
      Swal.fire({
        title: 'ยืนยันการอัพโหลด ?',
        text: "คุณยืนยันการอัพโหลด ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.UploadsImgDocInModal()
        }
      })
    },
    async UploadsImgDocInModal() {
      let files = this.$refs.dropzoneInModal.getAcceptedFiles();
      if (files.length === 0) return;

      let pathFile = "";
      let formName = "file_upload";
      switch (this.tabIndex) {
        case 1:
          pathFile = "/invoice";
          formName = "file_upload_invoice";
          break;
        case 2:
          pathFile = "/approval";
          formName = "file_upload_approval";
          break;
        case 3:
          pathFile = "/parts";
          formName = "file_upload_parts";
          break;
      }

      let formData = new FormData();
      files.forEach(file => {
        if (file.type === "application/pdf") {
          formData.append(formName, file);
        } else {
          const blob = this.dataURLtoBlob(file.dataURL);
          formData.append(formName, blob, file.name);
        }
      });

      this.$refs["uploadsImgDocModal"].hide();

      // แสดง loading UI ด้วยภาพเคลื่อนไหว
      Swal.fire({
        title: 'กำลังอัพโหลด...',
        html: `
                <div class="custom-loading">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="80" height="80">
                    <circle cx="50" cy="50" r="40" stroke="#3699FE" stroke-width="8" fill="none" stroke-linecap="round">
                      <animate attributeName="stroke-dasharray" dur="2s" repeatCount="indefinite"
                              values="0 251.2;188.4 62.8;251.2 0"/>
                      <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite"
                              values="0;0;-251.2"/>
                    </circle>
                  </svg>
                  <p>กรุณารอสักครู่</p>
                </div>
              `,
        showConfirmButton: false,
        allowOutsideClick: false
      });

      try {
        const response = await new Promise((resolve, reject) => {
          FetchService.post(`/upload/multiple${pathFile}`, formData, resolve, reject);
        });

        const res = JSON.parse(response);
        if (res?.uploadedFiles) {
          this.form.files = res.uploadedFiles.map(e => ({
            filename: e.name,
            size: e.size
          }));
          await this.UpdateImgDocInPlan();
        }

        // ปิด loading UI และแสดงข้อความสำเร็จ
        Swal.fire({
          title: 'สำเร็จ',
          html: 'ไฟล์ของคุณบันทึกเรียบร้อยแล้ว',
          icon: 'success',
          timer: 1000,
        }).then(() => {
          this.getPlanById();
          this.formEditImgDocCancel();
        });
      } catch (error) {
        // กรณีเกิดข้อผิดพลาด
        Swal.fire({
          title: 'เกิดข้อผิดพลาด',
          html: 'ไม่สามารถอัพโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
        });
      }
    },
    UpdateImgDocInPlan() {

      let sendBody = JSON.stringify({
        "files": this.form.files
      })

      let pathFile = ""
      if (this.tabIndex == 1) {
        pathFile = "/invoice"
      } else if (this.tabIndex == 2) {
        pathFile = "/approval"
      } else if (this.tabIndex == 3) {
        pathFile = "/parts"
      }

      let that = this
      FetchService.post(`/addimageplan${pathFile}/${this.planByIdData.planJobID}`, sendBody, res => {
        Swal.fire({
          title: 'สำเร็จ',
          html: 'ไฟล์ของคุณบันทึกเรียบร้อยแล้ว',
          icon: 'success',
          timer: 1000,
        }).then((result) => {
          that.getPlanById()
          that.formEditImgDocCancel()
        })
      })
    },
    calTotalCostCreateForm() {
      let create = this.equipmentCreateForm
      if (this.equipmentCreateForm.equipmentCost && this.equipmentCreateForm.equipmentAmount) {
        this.equipmentCreateForm.equipmentTotalCost = Number(this.equipmentCreateForm.equipmentCost) * Number(this.equipmentCreateForm.equipmentAmount)
      }
    },
    toggleSelection(item) {
      this.$set(item, 'selected', !item.selected); // Reactive update
      this.updateTable(); // บังคับ rerender
    },
    updateTable() {
      this.tableKey++; // เปลี่ยนค่า key เพื่อให้ table rerender
    },
    rowClass(item) {
      return item.selected ? 'bg-selected' : '';
    },
    formEditEquipment(state) {
      this.equipmentState = state
    },
    updateTotals() {

      const totalCost = this.equipmentOffered.items.reduce(
        (sum, item) => item.selected ? (sum + (Number(item.cost) || 0) * (Number(item.amount) || 1)) : sum + 0,
        0
      );

      const totalPrice = this.equipmentOffered.items.reduce(
        (sum, item) => item.selected ? sum + (Number(item.price) || 0) : sum + 0,
        0
      );

      const discount = parseFloat(this.equipmentOffered?.discount) || 0;
      const netTotal = totalPrice - discount;

      this.equipmentOffered.totalCost = totalCost || 0;
      this.equipmentOffered.totalPrice = totalPrice || 0;
      this.equipmentOffered.netTotal = netTotal;
    },
    equipmentActionSelect() {
      this.equipmentOffered.items = this.equipmentOffered.items.map(e => {
        return {
          ...e,
          selected: true
        }
      })
    },
  },
  watch: {
    tabIndex(newVal, oldVal) {
      console.log(`Tab changed from ${oldVal} to ${newVal}`);
      const that = this
      console.log("newVal", newVal)
      switch (newVal) {
        case 1:
          that.dropzoneStage = 'editNew_2'
          that.formEditImgDocCancel()
          break;
        case 2:
          that.dropzoneStage = 'editNew_3'
          that.formEditImgDocCancel()
          break;
        case 3:
          that.dropzoneStage = 'editNew_4'
          that.formEditImgDocCancel()
          break;
        default:
          that.dropzoneStage = 'editNew'
          that.formEditImgDocCancel()
      }
    },
    'equipmentOffered.discount': 'updateTotals',
    'equipmentOffered.items': {
      handler: 'updateTotals',
      deep: true,
    },
  },
};
</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

.plans-form-select {
  min-width: 20%;
}

.plans-form-select-lg {
  min-width: 30%;
}

.plans-form-select-lx {
  min-width: 40%;
}

.flex-content-end {
  display: flex;
  justify-content: end;
}

.btn-width-100 {
  width: 100px;
}

.btn-width-150 {
  width: 150;
}

.plans-form-job-status-date {
  margin-left: 1rem;
  font-size: 12px;
  background-color: #A0D911;
  padding: 0px 5px 0px 5px;
  border-radius: 5px;
}

.mx-datepicker {
  width: 100%;
}

.mx-input {
  height: calc(1.5em + 0.75rem);
}

.select2-container--bootstrap4.select2-container--disabled .select2-selection,
.select2-container--bootstrap4.select2-container--disabled.select2-container--focus .select2-selection {
  cursor: default;
  background-color: #F3F6F9;
}

.dz-progress,
.dz-error-message {
  display: none !important;
}

.vue-dropzone {
  border: 5px dotted #e5e5e5;
}

.image {
  width: calc(25% - 10px);
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

.image-container .image:hover {
  transform: scale(1.05);
  /* เพิ่มขนาดของรูปภาพ */
  transition: transform 0.3s ease;
  /* เพิ่มเอฟเฟกต์การเปลี่ยนขนาดด้วย transition */
}

.custom-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-loading svg {
  margin-bottom: 10px;
}

.bg-selected {
  background-color: #dff0d8 !important;
  /* สีเขียวอ่อน */
}
</style>